// Action Types
export const FETCH_SUPPLIERS_START = 'ENTITY/FETCH_SUPPLIERS_START';
export const FETCH_SUPPLIERS_SUCCESS = 'ENTITY/FETCH_SUPPLIERS_SUCCESS';
export const FETCH_SUPPLIERS_ERROR = 'ENTITY/FETCH_SUPPLIERS_ERROR';
export const SET_SELECTED_SUPPLIER = 'ENTITY/SET_SELECTED_SUPPLIER';
export const SET_SELECTED_ENTITY = 'ENTITY/SET_SELECTED_ENTITY';
export const RESET_ENTITY_STATE = 'ENTITY/RESET_ENTITY_STATE';

const initialState = {
  suppliers: [],
  suppliersList: [],
  selectedSupplier: '',
  selectedEntity: '',
  selectedSupplierData: null,
  loading: false,
  error: null,
};

const entityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUPPLIERS_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_SUPPLIERS_SUCCESS:
      const suppliersList = Array.isArray(action.payload) 
        ? action.payload.flatMap((item) => item.suppliers_list || []) 
        : [];
      
      // Only auto-select if no selection exists yet
      const finalSelectedSupplier = state.selectedSupplier || (suppliersList.length > 0 ? suppliersList[0].id : '');
      const selectedSupplierData = suppliersList.find((s) => s.id === finalSelectedSupplier);
      
      // For entity: preserve existing valid selection or auto-select first
      let finalSelectedEntity = state.selectedEntity;
      if (selectedSupplierData?.entity_info?.length > 0) {
        // Check if current entity is valid for the selected supplier
        const isCurrentEntityValid = selectedSupplierData.entity_info.some(
          (entity) => entity.esi_id === state.selectedEntity
        );
        
        // Only change entity if current one is invalid or empty
        if (!isCurrentEntityValid) {
          finalSelectedEntity = selectedSupplierData.entity_info[0].esi_id;
        }
      } else {
        finalSelectedEntity = '';
      }
      
      return {
        ...state,
        loading: false,
        suppliers: action.payload,
        suppliersList,
        selectedSupplier: finalSelectedSupplier,
        selectedSupplierData: selectedSupplierData,
        selectedEntity: finalSelectedEntity,
        error: null,
      };

    case FETCH_SUPPLIERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        suppliers: [],
        suppliersList: [],
      };

    case SET_SELECTED_SUPPLIER:
      const newSupplierData = state.suppliersList.find((s) => s.id === action.payload);
      
      // Check if current entity is valid for the new supplier
      let newSelectedEntity = state.selectedEntity;
      if (newSupplierData?.entity_info?.length > 0) {
        const isCurrentEntityValid = newSupplierData.entity_info.some(
          (entity) => entity.esi_id === state.selectedEntity
        );
        
        // If current entity is not valid for new supplier, select first available
        if (!isCurrentEntityValid) {
          newSelectedEntity = newSupplierData.entity_info[0].esi_id;
        }
      } else {
        // No entities available for new supplier
        newSelectedEntity = '';
      }
      
      return {
        ...state,
        selectedSupplier: action.payload,
        selectedSupplierData: newSupplierData,
        selectedEntity: newSelectedEntity,
      };

    case SET_SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.payload,
      };

    case RESET_ENTITY_STATE:
      return initialState;

    default:
      return state;
  }
};

export default entityReducer;
